
      import OnlineEnquiry from './online-enquiry.vue'
      import type { App, Plugin } from 'vue'

      export const OnlineEnquiryPlugin: Plugin = {
        install(app: App) {
          app.component('OnlineEnquiry', OnlineEnquiry)
        },
      }
      export { OnlineEnquiry }
      